import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { VideoStoreAccessLog } from '../components/video-store/video-store-access-log';

@Injectable({
  providedIn: 'root'
})
export class VideoStoreService {

  apiUrl = environment.apiUrl
  
      httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };
  
      constructor(private http: HttpClient,private _authservice:AuthService,private langserivce:LanguageService) { }

      getVideosByLanguage():Observable<any[]>{
        const token = this._authservice.getAuthToken();
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });   
        let params = new HttpParams();
        params = params.append('languageId', this.langserivce.getCurretnLang())
        return this.http.get<any[]>(this.apiUrl + 'videoStore/getAllVideosByLanguage',{headers:headers,params:params})
      }

      logAccessForVideos(videoAccessLog:VideoStoreAccessLog)
      {
        const token = this._authservice.getAuthToken();
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
        return this.http.post(this.apiUrl + 'videoStore/logAccessForVideo',videoAccessLog,{headers:headers})
      }

      getAllProgramPacksByLanguage():Observable<any>
      {
        const token = this._authservice.getAuthToken();
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
        let params = new HttpParams();
        params = params.append('languageId', this.langserivce.getCurretnLang())
        return this.http.get<any>(this.apiUrl + 'programPack/getAllProgramPacksByLanguage',{headers:headers,params:params})
      }
  
}
